var electron;
if (!process.env.VUE_APP_IS_WEB) {
  electron = require("electron");
}

const API_WEB_APP_LINK = process.env.VUE_APP_API_WEB_APP_LINK;
const API_USER_LINK = process.env.VUE_APP_API_USER_LINK;
const MERCURE_LINK = process.env.VUE_APP_MERCURE_LINK;

function getPublicPath() {
  if (process.env.NODE_ENV === "production") {
    return process.env.VUE_APP_IS_WEB ? "./public" : electron.remote.app.getPath("userData");
  } else {
    return process.env.VUE_APP_IS_WEB ? API_WEB_APP_LINK : "./public";
  }
}
const PUBLIC_PATH = getPublicPath();

export default Object.freeze({
  MERCURE_LINK() {
    return MERCURE_LINK;
  },
  API_WEB_APP_MEDIA_LINK(fileUrl) {
    return API_WEB_APP_LINK + fileUrl;
  },
  /** File system  */
  PUBLIC_PATH() {
    return PUBLIC_PATH;
  },
  MEDIA_PATH() {
    return PUBLIC_PATH + "/media";
  },
  /** AUTH */
  REGISTER() {
    return API_USER_LINK + "/register";
  },
  REGISTER_BUILDING_OWNER() {
    return API_USER_LINK + "/users/register/building-owner";
  },
  REGISTER_MEETING_GUEST() {
    return API_USER_LINK + "/users/register/meeting-guest";
  },
  REGISTER_CONTACT() {
    return API_USER_LINK + "/users/register/contact";
  },
  LOGIN() {
    return API_USER_LINK + "/token/login";
  },
  TOKEN_REFRESH() {
    return API_USER_LINK + "/token/refresh";
  },

  /** FORGOT PASSWORD */
  CHECK_EMAIL() {
    return API_USER_LINK + "/users/check-email";
  },
  CHECK_USERNAME() {
    return API_USER_LINK + "/users/check-username-ag";
  },
  CHECK_VERIFICATION_CODE() {
    return API_USER_LINK + "/users/verification-code/check";
  },
  SET_PASSWORD() {
    return API_USER_LINK + "/users/verification-code/set-password";
  },

  /** RESET PASSWORD */
  AG_RESET_USER_PASSWORD() {
    return API_USER_LINK + "/ag-reset-user-password";
  },

  /** AUTH DESKTOP */
  CHECK_USER() {
    return API_USER_LINK + "/users/check";
  },
  // FIXME: renounced
  CHECK_EMAIL_DESKTOP() {
    return API_USER_LINK + "/users/check-email";
  },
  CHECK_VERIFICATION_CODE_DESKTOP() {
    return API_USER_LINK + "/users/verification-code/check";
  },
  SET_PASSWORD_DESKTOP() {
    return API_USER_LINK + "/users/verification-code/set-password";
  },

  /** USER */
  USER_GET(id) {
    return API_USER_LINK + "/users/" + id;
  },
  USER_PUT(id) {
    return API_USER_LINK + "/users/" + id;
  },

  /** FIXME: SYNC TABLE */
  SYNC_TABLE_FETCH() {
    return API_WEB_APP_LINK + "/sync_web_tables?pagination=false";
  },
  SYNC_TABLE_GET_OBJECTS_TO_SYNC() {
    return API_WEB_APP_LINK + "/sync_web_tables/get_objects_to_sync";
  },
  SYNC_TABLE_SYNC_VALUES_IN_DB(appId) {
    // HACK: appId .. to be able to ignore adding in sync table for current app
    return API_WEB_APP_LINK + `/sync_web_tables/sync_values_in_db?appId=${appId}&isSyncing=true`;
  },
  SYNC_TABLE_DELETE_ROWS() {
    return API_WEB_APP_LINK + "/sync_web_tables/delete_rows";
  },
  // ???: ..
  SYNC_TABLE_GET(id) {
    return API_WEB_APP_LINK + "/sync_web_tables/" + id;
  },
  SYNC_TABLE_POST() {
    return API_WEB_APP_LINK + "/sync_web_tables";
  },
  SYNC_TABLE_PUT(id) {
    return API_WEB_APP_LINK + "/sync_web_tables/" + id;
  },
  SYNC_TABLE_DELETE(id) {
    return API_WEB_APP_LINK + "/sync_web_tables/" + id;
  },

  /** BUILDINGS */
  BUILDING_DOWNLOAD() {
    return API_WEB_APP_LINK + "/buildings/download?pagination=false";
  },
  BUILDING_QUERY_FETCH_PROPERTIES(agencyId, properties) {
    return API_WEB_APP_LINK + `/buildings?pagination=false&agency_id=${agencyId}${properties}`;
  },
  BUILDING_FETCH(agencyId) {
    return API_WEB_APP_LINK + `/buildings?pagination=false&agency_id=${agencyId}`;
  },
  BUILDING_QUERY_FETCH() {
    return API_WEB_APP_LINK + "/buildings";
  },
  BUILDING_GET(id) {
    return API_WEB_APP_LINK + "/buildings/" + id;
  },
  BUILDING_POST() {
    return API_WEB_APP_LINK + "/buildings";
  },
  BUILDING_PUT(id) {
    return API_WEB_APP_LINK + "/buildings/" + id;
  },
  BUILDING_DELETE(id) {
    return API_WEB_APP_LINK + "/buildings/" + id;
  },
  BUILDING_CUSTOM_DELETE(id) {
    return API_WEB_APP_LINK + "/buildings/delete/" + id;
  },
  BUILDING_MAJORITIES_BY_BUILDING(buildingId) {
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_majorities?pagination=false`;
  },
  BUILDING_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/buildings/meeting_register";
  },
  BUILDINGS_LIST() {
    return API_WEB_APP_LINK + "/buildings/list";
  },

  /** BUILDING LOTS */
  BUILDING_LOT_DOWNLOAD() {
    return API_WEB_APP_LINK + "/building_lots/download?pagination=false";
  },
  BUILDING_LOT_FETCH(buildingId) {
    // NOTE: get only the ones that belong to current building
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_lots?pagination=false`;
  },
  BUILDING_LOT_GET(id) {
    return API_WEB_APP_LINK + "/building_lots/" + id;
  },
  BUILDING_LOT_POST() {
    // NOTE: create + attach building owner
    return API_WEB_APP_LINK + "/building_lots";
  },
  BUILDING_LOT_PUT(id) {
    return API_WEB_APP_LINK + "/building_lots/" + id;
  },
  BUILDING_LOT_DELETE(id) {
    return API_WEB_APP_LINK + "/building_lots/" + id;
  },
  BUILDING_LOT_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/building_lots/meeting_register";
  },

  /** BUILDING-OWNER-BUILDING-LOT */
  BUILDING_OWNER_BUILDING_LOT_DOWNLOAD() {
    return API_WEB_APP_LINK + `/building_owner_building_lots/download?pagination=false`;
  },
  BUILDING_OWNER_BUILDING_LOT_FETCH(buildingOwnerId) {
    return (
      API_WEB_APP_LINK +
      `/building_owners/${buildingOwnerId}/building_owner_building_lots?pagination=false`
    );
  },
  BUILDING_OWNER_BUILDING_LOT_POST() {
    return API_WEB_APP_LINK + "/building_owner_building_lots";
  },
  BUILDING_OWNER_BUILDING_LOT_DELETE(id) {
    return API_WEB_APP_LINK + "/building_owner_building_lots/" + id;
  },

  /** BUILDING OWNER VOTING RIGHTS */
  BUILDING_OWNER_VOTING_RIGHT_DOWNLOAD() {
    return API_WEB_APP_LINK + `/building_owner_voting_rights/download?pagination=false`;
  },
  BUILDING_OWNER_VOTING_RIGHT_FETCH(BuildingOwnerBuildingLotId) {
    // NOTE: get voting rights that belong to building owner building lot
    return (
      API_WEB_APP_LINK +
      `/building_owner_building_lots/${BuildingOwnerBuildingLotId}/building_owner_voting_rights?pagination=false`
    );
  },
  BUILDING_OWNER_VOTING_RIGHT_POST() {
    return API_WEB_APP_LINK + "/building_owner_voting_rights";
  },
  BUILDING_OWNER_VOTING_RIGHT_PUT(id) {
    return API_WEB_APP_LINK + "/building_owner_voting_rights/" + id;
  },
  BUILDING_OWNER_VOTING_RIGHT_DELETE(id) {
    return API_WEB_APP_LINK + "/building_owner_voting_rights/" + id;
  },

  /** BUILDING OWNERS */
  BUILDING_OWNER_DOWNLOAD() {
    return API_WEB_APP_LINK + `/building_owners/download?pagination=false`;
  },
  BUILDING_OWNER_FETCH(buildingId) {
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_owners`;
  },
  BUILDING_OWNER_QUERY_FETCH(buildingId) {
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_owners`;
  },
  BUILDING_OWNER_GET(id) {
    return API_WEB_APP_LINK + "/building_owners/" + id;
  },
  BUILDING_OWNER_POST() {
    return API_WEB_APP_LINK + "/building_owners";
  },
  BUILDING_OWNER_PUT(id) {
    return API_WEB_APP_LINK + "/building_owners/" + id;
  },
  BUILDING_OWNER_DELETE(id) {
    return API_WEB_APP_LINK + "/building_owners/" + id;
  },
  BUILDING_OWNER_CUSTOM_DELETE(id) {
    return API_WEB_APP_LINK + "/building_owners/delete/" + id;
  },
  BUILDING_OWNER_BULK_DELETE() {
    return API_WEB_APP_LINK + "/building_owners/bulk/delete";
  },
  BUILDING_OWNER_IMPORT() {
    return API_WEB_APP_LINK + "/building_owners/bulk/import";
  },
  BUILDING_OWNER_ADD_EDIT_PROCESS() {
    return API_WEB_APP_LINK + "/building_owners/add-process";
  },
  BUILDING_OWNER_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/building_owners/meeting_register";
  },
  BUILDING_OWNER_SET_LRE_AGREEMENT() {
    return API_WEB_APP_LINK + "/building_owners/set_lre_agreement";
  },
  BUILDING_OWNERS_TOTAL_VOTING_RIGHT_PARTS(buildingId) {
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_owners_total_voting_right_parts`;
  },
  BUILDING_OWNERS_BUILDING_CATALOG() {
    return API_WEB_APP_LINK + `/building_owners/building_catalog`;
  },

  CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED() {
    return API_WEB_APP_LINK + "/depart_building_lots/check_if_can_be_executed";
  },
  EXECUTE_DEPART_BUILDING_LOT() {
    return API_WEB_APP_LINK + "/depart_building_lots/execute";
  },

  /** CONTACT */
  CONTACT_DOWNLOAD() {
    return API_WEB_APP_LINK + "/contacts/download?pagination=false";
  },
  CONTACT_FETCH(buildingId) {
    return API_WEB_APP_LINK + `/buildings/${buildingId}/contacts?pagination=false`;
  },
  CONTACT_PUT(id) {
    return API_WEB_APP_LINK + "/contacts/" + id;
  },
  CONTACT_POST() {
    return API_WEB_APP_LINK + "/contacts";
  },
  CONTACT_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/contacts/meeting_register";
  },

  /** MAJORITIES */
  MAJORITY_DOWNLOAD() {
    return API_WEB_APP_LINK + "/majorities/download?pagination=false";
  },
  MAJORITY_FETCH() {
    return API_WEB_APP_LINK + "/majorities?pagination=false";
  },
  MAJORITY_QUERY_FETCH() {
    return API_WEB_APP_LINK + `/majorities`;
  },
  MAJORITY_GET(id) {
    return API_WEB_APP_LINK + "/majorities/" + id;
  },
  MAJORITY_POST() {
    return API_WEB_APP_LINK + "/majorities";
  },
  MAJORITY_PUT(id) {
    return API_WEB_APP_LINK + "/majorities/" + id;
  },
  MAJORITY_DELETE(id) {
    return API_WEB_APP_LINK + "/majorities/" + id;
  },
  MAJORITY_CUSTOM_UPDATE(id) {
    return API_WEB_APP_LINK + `/majorities/${id}/custom-update`;
  },

  /** MANDATES */
  MEETING_MANDATES(id) {
    return API_WEB_APP_LINK + `/meetings/${id}/mandates?pagination=false`;
  },
  MANDATE_DOWNLOAD() {
    return API_WEB_APP_LINK + "/mandates/download?pagination=false";
  },
  MANDATE_QUERY_FETCH(meetingId) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/mandates?pagination=false`;
  },
  MANDATE_GET(id) {
    return API_WEB_APP_LINK + "/mandates/" + id;
  },
  MANDATE_POST() {
    return API_WEB_APP_LINK + "/mandates";
  },
  MANDATE_PUT(id) {
    return API_WEB_APP_LINK + "/mandates/" + id;
  },
  MANDATE_DELETE(id) {
    return API_WEB_APP_LINK + "/mandates/" + id;
  },
  MANDATE_UPDATE_MULTIPLE_LAST_SEEN() {
    return API_WEB_APP_LINK + "/mandates/update-multiple-last-seen";
  },
  MANDATE_GET_DEFAULT_INVITATION_BROADCAST(meetingId) {
    return API_WEB_APP_LINK + "/mandates/set_default_invitation_broadcast?meeting_id=" + meetingId;
  },
  MANDATE_GET_MANUAL_INVITATION_BROADCAST(meetingId) {
    return API_WEB_APP_LINK + "/mandates/get_manual_invitation_broadcast?meeting_id=" + meetingId;
  },
  MEETING_MANDATES_WITHOUT_RESOLUTION_VOTES(meetingId) {
    return API_WEB_APP_LINK + `/mandates/get-without_resolution_votes?meeting_id=${meetingId}`;
  },
  MANDATE_GET_DOC_REQUESTS(mandateId) {
    return API_WEB_APP_LINK + `/mandates/${mandateId}/get_doc_requests`;
  },
  GET_MANDATES_DOCS_BY_MEETING() {
    return API_WEB_APP_LINK + `/mandates/get_docs_by_meeting`;
  },

  /** MEDIA HACK: .json .. resolve Error: Exceeded maxRedirects. Probably stuck in a redirect loop */
  MEDIA_DOWNLOAD() {
    return API_WEB_APP_LINK + "/media/download?pagination=false";
  },
  MEDIA_GET_FILES() {
    return API_WEB_APP_LINK + "/media/get-files?pagination=false";
  },
  MEDIA_BULK_DELETE() {
    return API_WEB_APP_LINK + "/media/bulk-delete?pagination=false";
  },
  MEDIA_FETCH() {
    return API_WEB_APP_LINK + "/media.json?pagination=false";
  },
  MEDIA_POST() {
    return API_WEB_APP_LINK + "/media.json";
  },
  MEDIA_GET(id) {
    return API_WEB_APP_LINK + "/media/" + id;
  },
  // ???:
  MEDIA_PUT(id) {
    return API_WEB_APP_LINK + "/media/" + id;
  },
  MEDIA_DELETE(id) {
    return API_WEB_APP_LINK + "/media/" + id;
  },
  MEDIA_GET_IN_BASE64(id) {
    return API_WEB_APP_LINK + "/media/" + id + "/get-in-base64";
  },
  MEDIA_CREATE_FROM_BASE64() {
    return API_WEB_APP_LINK + "/media/create-base64-media";
  },
  MEDIA_CHECK_PDF_FORMAT() {
    return API_WEB_APP_LINK + "/media/check-pdf-format";
  },
  MEDIA_UPDATE_PDF_POSITION() {
    return API_WEB_APP_LINK + "/media/update-pdf-position";
  },
  MEDIA_GET_SIGNATURES() {
    return API_WEB_APP_LINK + "/media/get-signatures";
  },

  /** MEETING-RESOLUTION */
  MEETING_RESOLUTION_DOWNLOAD() {
    return API_WEB_APP_LINK + `/meeting_resolutions/download?pagination=false`;
  },
  MEETING_RESOLUTION_FETCH(meetingId) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/meeting_resolutions?pagination=false`;
  },
  MEETING_RESOLUTION_GET_LAST_POSITION(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/get_last_position/" + id;
  },
  MEETING_RESOLUTION_QUERY_FETCH(meetingId) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/meeting_resolutions`;
  },
  MEETING_QUERY_FETCH_PROPERTIES(agencyId, properties) {
    return API_WEB_APP_LINK + `/meetings?pagination=false&agency_id=${agencyId}${properties}`;
  },
  MEETING_RESOLUTION_GET(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/" + id;
  },
  MEETING_RESOLUTION_PUT(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/" + id;
  },
  MEETING_RESOLUTION_DELETE(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/" + id;
  },
  // ... use just this instead of the other 3
  MEETING_RESOLUTION_POST() {
    return API_WEB_APP_LINK + "/meeting_resolutions";
  },
  // ???: ..
  MEETING_RESOLUTION_POST_NEW() {
    return API_WEB_APP_LINK + "/meeting_resolutions";
  },
  MEETING_RESOLUTION_POST_FROM_RESOLUTIONS() {
    return API_WEB_APP_LINK + "/meeting_resolutions";
  },
  MEETING_RESOLUTION_POST_FROM_CATALOGS() {
    return API_WEB_APP_LINK + "/meeting_resolutions";
  },
  MEETING_RESOLUTION_DUPLICATE_MEDIA() {
    return API_WEB_APP_LINK + "/meeting_resolutions/duplicate_media";
  },
  MEETING_RESOLUTION_SAVE_POSITION() {
    return API_WEB_APP_LINK + "/meeting_resolutions/save_position";
  },
  MEETING_RESOLUTION_UPDATE_RESOLUTIONS_NUMBERS() {
    return API_WEB_APP_LINK + "/meeting_resolutions/update_meeting_resolutions_numbers";
  },
  UPDATE_MEETING_RESOLUTION_WITH_MEDIA(id) {
    return API_WEB_APP_LINK + "/update-meeting-resolution-with-media/" + id;
  },
  CREATE_MEETING_RESOLUTION_WITH_MEDIA() {
    return API_WEB_APP_LINK + "/create-meeting-resolution-with-media";
  },
  MEETING_RESOLUTION_CREATE_DURING_MEETING() {
    return API_WEB_APP_LINK + "/meeting_resolutions/create_meeting_resolution_during_meeting";
  },
  MEETING_RESOLUTION_DELETE_DURING_MEETING(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/delete_meeting_resolution_during_meeting/" + id;
  },
  MEETING_RESOLUTION_RESET(id) {
    return API_WEB_APP_LINK + "/meeting_resolutions/" + id + "/reset";
  },
  // ???: ..

  /** MEETINGS */
  MEETING_DOWNLOAD(id) {
    return API_WEB_APP_LINK + "/meetings/download?pagination=false";
  },
  MEETING_QUERY_FETCH(properties) {
    return API_WEB_APP_LINK + `/meetings?${properties}`; // ???: ..
  },
  MEETING_GET(id) {
    return API_WEB_APP_LINK + "/meetings/" + id;
  },
  MEETING_GET_DOCUMENTS(id) {
    return API_WEB_APP_LINK + "/meetings/" + id + "/documents";
  },
  MEETING_POST() {
    return API_WEB_APP_LINK + "/meetings";
  },
  MEETING_PUT(id) {
    return API_WEB_APP_LINK + "/meetings/" + id;
  },
  MEETING_WITH_RELATED_MEDIA(id) {
    return API_WEB_APP_LINK + `/meetings/${id}/with-related`;
  },
  MEETING_SEND_NOTIFICATIONS() {
    return API_WEB_APP_LINK + "/meetings/send-notifications";
  },
  CREATE_MANDATES_FOR_MEETING() {
    return API_WEB_APP_LINK + "/meetings/create-mandates-for-meeting";
  },
  MEETING_INVITATION_READY_TO_SEND(id) {
    return API_WEB_APP_LINK + `/meetings/${id}/invitation_ready_to_send`;
  },
  MEETING_DUPLICATE() {
    return API_WEB_APP_LINK + "/meetings/duplicate-meeting";
  },
  MEETING_START(id) {
    return API_WEB_APP_LINK + "/meetings/" + id + "/start";
  },
  MEETING_RESET(id) {
    return API_WEB_APP_LINK + "/meetings/" + id + "/reset";
  },
  MEETINGS_GET_BY_BUILDING(buildingId) {
    return API_WEB_APP_LINK + "/meetings/get_by_building?building_id=" + buildingId;
  },
  MEETINGS_UPDATE_MEETING_RESOLUTION_STATUS_NOT_VOTED(meetingId) {
    return API_WEB_APP_LINK + "/meetings/" + meetingId + "/meeting_resolutions_status_not_voted";
  },
  MEETING_ARCHIVE(meetingId, userMediaId) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/archive?user_media_id=${userMediaId}`;
  },
  MEETING_DELETE(meetingId, doZipBackup) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/delete?zip_backup=${doZipBackup}`;
  },
  MEETING_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/meetings/meeting_register";
  },
  MEETING_UPDATE_DOCS_PRINT_COLOR(meetingId) {
    return API_WEB_APP_LINK + "/meetings/" + meetingId + "/update_docs_print_color";
  },
  MEETING_UPDATE_CURRENT_RESOLUTION(meetingId) {
    return API_WEB_APP_LINK + "/meetings/" + meetingId + "/update_current_resolution";
  },
  MEETING_UPDATE_MINUTES(meetingId) {
    return API_WEB_APP_LINK + "/meetings/" + meetingId + "/update_minutes";
  },

  /** RESOLUTIONS CATALOGS */
  RESOLUTION_CATALOG_DOWNLOAD() {
    return API_WEB_APP_LINK + "/resolution_catalogs/download?pagination=false";
  },
  RESOLUTION_CATALOG_FETCH() {
    return API_WEB_APP_LINK + "/resolution_catalogs?pagination=false";
  },
  RESOLUTION_CATALOG_QUERY_FETCH() {
    return API_WEB_APP_LINK + "/resolution_catalogs"; // ???: ..
  },
  RESOLUTION_CATALOG_GET(id) {
    return API_WEB_APP_LINK + "/resolution_catalogs/" + id;
  },
  RESOLUTION_CATALOG_POST() {
    return API_WEB_APP_LINK + "/resolution_catalogs";
  },
  RESOLUTION_CATALOG_PUT(id) {
    return API_WEB_APP_LINK + "/resolution_catalogs/" + id;
  },
  RESOLUTION_CATALOG_DELETE(id) {
    return API_WEB_APP_LINK + "/resolution_catalogs/" + id;
  },
  RESOLUTION_CATALOG_DUPLICATE() {
    return API_WEB_APP_LINK + "/resolution_catalogs/" + id;
  },

  /** RESOLUTION-CATALOG-TAG */
  RESOLUTION_CATALOG_TAG_DOWNLOAD() {
    return API_WEB_APP_LINK + "/resolution_catalog_tags/download?pagination=false";
  },
  RESOLUTION_CATALOG_TAG_POST() {
    return API_WEB_APP_LINK + "/resolution_catalog_tags";
  },
  RESOLUTION_CATALOG_TAG_DELETE(id) {
    return API_WEB_APP_LINK + "/resolution_catalog_tags/" + id;
  },
  RESOLUTION_CATALOG_CHECK_POSITION() {
    return API_WEB_APP_LINK + "/resolution_catalogs/check_position";
  },

  /** RESOLUTION-VOTE */
  RESOLUTION_VOTE_DOWNLOAD(id) {
    return API_WEB_APP_LINK + "/resolution_votes/download?pagination=false";
  },
  RESOLUTION_VOTE_FETCH(meetingResolutionId) {
    return (
      API_WEB_APP_LINK +
      `/meeting_resolutions/${meetingResolutionId}/resolution_votes?pagination=false`
    );
  },
  RESOLUTION_VOTES_FETCH_BY_MANDATE(mandateId) {
    return API_WEB_APP_LINK + `/mandates/${mandateId}/resolution_votes?pagination=false`;
  },
  RESOLUTION_VOTE_GET(id) {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  RESOLUTION_VOTE_POST() {
    return API_WEB_APP_LINK + "/resolution_votes";
  },
  RESOLUTION_VOTE_PUT(id) {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  // !!!: TODO: ...
  RESOLUTION_VOTE_BULK_VOTE() {
    return API_WEB_APP_LINK + "/resolution_votes/bulk/vote";
  },
  RESOLUTION_VOTE_BULK_DELETE() {
    return API_WEB_APP_LINK + "/resolution_votes/bulk/delete";
  },
  RESOLUTION_VOTE_BULK_CREATE() {
    return API_WEB_APP_LINK + "​/resolution_votes/bulk/create";
  },
  RESOLUTION_VOTE_BULK_UPDATE() {
    return API_WEB_APP_LINK + "/resolution_votes/bulk/update";
  },
  // ???: ...
  RESOLUTION_VOTE_BULK_SELECT(id) {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  RESOLUTION_VOTE_BULK_DESELECT() {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  RESOLUTION_VOTE_RESET_VOTES(id) {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  RESOLUTION_VOTE_SET_VOTES_ABSTAIN() {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },
  RESET_IGNORED_CORRESPONDENCE() {
    return API_WEB_APP_LINK + "/resolution_votes/bulk/reset_ignored_correspondence";
  },
  RESOLUTION_VOTE_GET_IGNORED_CORRESPONDENCE(meetingId) {
    return API_WEB_APP_LINK + "/resolution_votes/ignored_correspondence?meeting_id=" + meetingId;
  },
  RESOLUTION_VOTE_BY_MEETING(meetingId) {
    return API_WEB_APP_LINK + "/resolution_votes/by_meeting?meeting_id=" + meetingId;
  },

  /** RESOLUTIONS */
  RESOLUTION_DOWNLOAD() {
    return API_WEB_APP_LINK + "/resolutions/download?pagination=false";
  },
  RESOLUTION_FETCH() {
    return API_WEB_APP_LINK + "/resolutions?pagination=false";
  },
  RESOLUTION_QUERY_FETCH(resolutionCatalogId) {
    return API_WEB_APP_LINK + `/resolution_catalogs/${resolutionCatalogId}/resolutions`;
  },
  RESOLUTION_GET(id) {
    return API_WEB_APP_LINK + "/resolutions/" + id;
  },
  RESOLUTION_POST() {
    return API_WEB_APP_LINK + "/resolutions";
  },
  RESOLUTION_PUT(id) {
    return API_WEB_APP_LINK + "/resolutions/" + id;
  },
  RESOLUTION_DELETE(id) {
    return API_WEB_APP_LINK + "/resolutions/" + id;
  },
  UPDATE_RESOLUTION_WITH_MEDIA(id) {
    return API_WEB_APP_LINK + "/update-resolution-with-media/" + id;
  },
  CREATE_RESOLUTION_WITH_MEDIA() {
    return API_WEB_APP_LINK + "/create-resolution-with-media";
  },

  /** TABLE HEADERS */
  TABLE_HEADER_GET(agencyId, slug) {
    return API_WEB_APP_LINK + `/table_headers?agency_id=${agencyId}&slug=${slug}`;
  },
  TABLE_HEADER_PUT(id) {
    return API_WEB_APP_LINK + "/table_headers/" + id;
  },

  /** TAGS */
  TAG_DOWNLOAD() {
    return API_WEB_APP_LINK + "/tags/download?pagination=false";
  },
  TAG_FETCH() {
    return API_WEB_APP_LINK + "/tags?pagination=false";
  },
  TAG_GET(id) {
    return API_WEB_APP_LINK + "/tags/" + id;
  },
  // ???: .. create + attach, attach, detach
  TAG_POST() {
    return API_WEB_APP_LINK + "/tags";
  },
  TAG_ATTACH() {},
  TAG_DETACH() {},
  TAG_PUT(id) {
    return API_WEB_APP_LINK + "/tags/" + id;
  },
  TAG_DELETE(id) {
    return API_WEB_APP_LINK + "/tags/" + id;
  },

  /** VOTING CATEGORIES */
  VOTING_CATEGORY_DOWNLOAD() {
    return API_WEB_APP_LINK + `/voting_categories/download?pagination=false`;
  },
  VOTING_CATEGORY_FETCH(buildingId) {
    // get only the ones that belong to current building
    return API_WEB_APP_LINK + `/buildings/${buildingId}/voting_categories?pagination=false`;
  },
  VOTING_CATEGORY_FETCH_WITH_RELATED(buildingId) {
    // get only the ones that belong to current building
    return API_WEB_APP_LINK + `/buildings/${buildingId}/voting_categories?pagination=false`;
  },
  VOTING_CATEGORY_FETCH_WITH_CHARGE_GENERAL(agencyId) {
    return (
      API_WEB_APP_LINK +
      `/voting_categories?agency_id=${agencyId}&is_charge_generale=1&pagination=false`
    );
  },
  VOTING_CATEGORY_QUERY_FETCH() {
    return API_WEB_APP_LINK + "/voting_categories";
  },
  VOTING_CATEGORY_GET(id) {
    return API_WEB_APP_LINK + "/voting_categories/" + id;
  },
  VOTING_CATEGORY_POST() {
    // create + attach building owner
    return API_WEB_APP_LINK + "/voting_categories";
  },
  VOTING_CATEGORY_PUT(id) {
    return API_WEB_APP_LINK + "/voting_categories/" + id;
  },
  VOTING_CATEGORY_DELETE(id) {
    return API_WEB_APP_LINK + "/voting_categories/" + id;
  },
  VOTING_CATEGORY_SET_OTHER_CHARGES_GENERALES_TO_FALSE() {
    return API_WEB_APP_LINK + "/voting_categories/bulk/set_other_charges_generales_to_false";
  },
  VOTING_CATEGORIES_BY_MEETING(meetingId) {
    return API_WEB_APP_LINK + "/voting_categories/get_by_meeting?meeting_id=" + meetingId;
  },
  VOTING_CATEGORY_CUSTOM_DELETE(id) {
    return API_WEB_APP_LINK + "/voting_categories/delete/" + id;
  },
  VOTING_CATEGORY_MEETING_REGISTER() {
    return API_WEB_APP_LINK + "/voting_categories/meeting_register";
  },

  /** MEETING_GUESTS */
  MEETING_MEETING_GUESTS(id) {
    return API_WEB_APP_LINK + "/meetings/" + id + "/meeting_guests";
  },
  MEETING_GUEST_DOWNLOAD(id) {
    return API_WEB_APP_LINK + "/meeting_guests/download?pagination=false";
  },
  MEETING_GUESTS() {
    return API_WEB_APP_LINK + "/meeting_guests?pagination=false";
  },
  MEETING_GUEST_GET(id) {
    return API_WEB_APP_LINK + "/meeting_guests/" + id;
  },
  MEETING_GUEST_POST() {
    return API_WEB_APP_LINK + "/meeting_guests";
  },
  MEETING_GUEST_PUT(id) {
    return API_WEB_APP_LINK + "/meeting_guests/" + id;
  },
  MEETING_GUEST_DELETE(id) {
    return API_WEB_APP_LINK + "/meeting_guests/" + id;
  },
  MEETING_GUEST_GET_BY_BUILDING(buildingId) {
    return API_WEB_APP_LINK + "/meeting_guests/get_by_building?building_id=" + buildingId;
  },
  MANDATE_PDF_CREATE_MERGE() {
    return API_WEB_APP_LINK + "/mandate/pdf/create/merge";
  },
  MANDATE_PDF_CREATE_MERGE_PV() {
    return API_WEB_APP_LINK + "/mandate/pdf/create/merge/pv";
  },
  MEETING_PDF_CREATE_SAVE_RETURN() {
    return API_WEB_APP_LINK + "/meeting/pdf/create/save/return";
  },
  MEETING_PDF_CREATE_RETURN() {
    return API_WEB_APP_LINK + "/meeting/pdf/create/return";
  },
  MANDATE_CORRESPONDENCE_VOTING(mandateId) {
    return API_WEB_APP_LINK + "/mandate/correspondence-voting";
  },
  CREATE_PDFS_TO_GENERATE_ROW() {
    return API_WEB_APP_LINK + "/create_pdfs_to_generate_row";
  },
  DUMMY_PDF_CREATE_RETURN() {
    return API_WEB_APP_LINK + "/dummy/pdf/create/return";
  },

  // Configurations
  CONFIGURATION_GET(id) {
    return API_WEB_APP_LINK + "/configurations/" + id;
  },
  CONFIGURATION_GET_BY_AGENCY(agencyId) {
    return API_WEB_APP_LINK + `/configurations?agency_id=${agencyId}`;
  },
  CONFIGURATION_POST() {
    return API_WEB_APP_LINK + "/configurations";
  },
  CONFIGURATION_PUT(id) {
    return API_WEB_APP_LINK + "/configurations/" + id;
  },
  CONFIGURATION_DELETE(id) {
    return API_WEB_APP_LINK + "/configurations/" + id;
  },

  // Recipients
  RECIPIENT_GET(id) {
    return API_WEB_APP_LINK + "/recipients/" + id;
  },
  RECIPIENT_GET_BY_AGENCY(agencyId) {
    return API_WEB_APP_LINK + `/recipients?agency_id=${agencyId}`;
  },
  RECIPIENTS_GET_BY_BUILDING_ID(buildingId) {
    return API_WEB_APP_LINK + `/recipients?building_id=${buildingId}&pagination=false&asl=0`;
  },
  RECIPIENT_POST() {
    return API_WEB_APP_LINK + "/recipients";
  },
  RECIPIENT_PUT(id) {
    return API_WEB_APP_LINK + "/recipients/" + id;
  },
  RECIPIENT_DELETE(id) {
    return API_WEB_APP_LINK + "/recipients/" + id;
  },
  RECIPIENTS_GET_BY_MEETING(meetingId) {
    return API_WEB_APP_LINK + "/recipients/get_by_meeting?meeting_id=" + meetingId;
  },

  // RecipientMeetingDocs
  RECIPIENT_MEETING_DOC_GET(id) {
    return API_WEB_APP_LINK + "/recipient_meeting_docs/" + id;
  },
  RECIPIENT_MEETING_DOC_POST() {
    return API_WEB_APP_LINK + "/recipient_meeting_docs";
  },
  RECIPIENT_MEETING_DOC_PUT(id) {
    return API_WEB_APP_LINK + "/recipient_meeting_docs/" + id;
  },
  RECIPIENT_MEETING_DOC_DELETE(id) {
    return API_WEB_APP_LINK + "/recipient_meeting_docs/" + id;
  },
  RECIPIENT_MEETING_DOC_BY_MEETING_ID() {
    return API_WEB_APP_LINK + `/recipient_meeting_docs`;
  },
  RECIPIENT_MEETING_DOC_FOR_ASL() {
    return API_WEB_APP_LINK + `/recipient_meeting_docs/get_by_meeting`;
  },

  // MeetingCorrespondenceVote

  MEETING_CORRESPONDENCE_VOTE_GET(id) {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes/" + id;
  },
  MEETING_CORRESPONDENCE_VOTE_GET_BY_MEETING(meetingId) {
    return (
      API_WEB_APP_LINK + `/meetings/${meetingId}/meeting_correspondence_votes?pagination=false`
    );
  },
  MEETING_CORRESPONDENCE_VOTE_GET_BY_AGENCY(agencyId) {
    return API_WEB_APP_LINK + `/meeting_correspondence_votes?agency_id=${agencyId}`;
  },
  MEETING_CORRESPONDENCE_VOTE_POST() {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes";
  },
  MEETING_CORRESPONDENCE_VOTE_PUT(id) {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes/" + id;
  },
  MEETING_CORRESPONDENCE_VOTE_DELETE(id) {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes/" + id;
  },

  // Admin notifications
  ADMIN_ERROR_NOTIFICAITON() {
    return API_WEB_APP_LINK + "/admin-notification/send-error-to-admin";
  },

  GENERALS() {
    return API_WEB_APP_LINK + "/generals";
  },

  INVOICE_GET_BY_MEETING() {
    return API_WEB_APP_LINK + "/invoices";
  },

  // BuildingMajorities
  BUILDING_MAJORITIES() {
    return API_WEB_APP_LINK + "/building_majorities";
  },
  BUILDING_MAJORITIES_BULK_MAJORITIES() {
    return API_WEB_APP_LINK + "/building_majorities/bulk_add_majorities";
  },

  MEETING_REGISTERS() {
    return API_WEB_APP_LINK + "/meeting_registers";
  },

  LIVEKIT_GET_ADMIN_TOKEN() {
    return API_WEB_APP_LINK + "/livekit/get-admin-token";
  },

  LIVEKIT_DISABLE_PARTICIPANT_TRACK() {
    return API_WEB_APP_LINK + "/livekit/disable-participant-track";
  },
});
